
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/shop/[[...slug]]",
      function () {
        return require("private-next-pages/search/shop/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/shop/[[...slug]]"])
      });
    }
  